import React from "react";
import moment from "moment";
import {
  UserPlusIcon,
  PencilIcon,
  ArrowDownIcon,
} from "@heroicons/react/24/solid";
import {
  Dialog,
  Card,
  CardHeader,
  Input,
  Typography,
  Button,
  CardBody,
  CardFooter,
  IconButton,
  Tooltip,
  Checkbox,
  Chip,
} from "@material-tailwind/react";
import {
  MagnifyingGlassIcon,
  ChevronUpDownIcon,
} from "@heroicons/react/24/outline";
import { Select, Option } from "@material-tailwind/react";
import { useEffect, useState } from "react";
import {
  getAuditData,
  createAuditData,
  editAuditData,
  getUserData,
  getPcidssv321Data,
  getPcidssv4Data,
} from "../../helperFunctions/apiFunction";
import { useAuthUserToken } from "../../hooks/useAuthUserToken";
import TableSkeleton from "../../components/Loaders/TableSkeleton";
import toast from "react-hot-toast";
import ExcelJS from "exceljs";
import TableRowWithShowMore from "../../components/TableRowWithShowMore";
import { useNavigate } from "react-router-dom";

const TABLE_HEAD_CONTROL = [
  "Requirement Id",
  "Requirement",
  "Control Id",
  "Description",
  "Select button",
];

const TABLE_ROWS_CONTROL = [
  {
    requirementTitle: "Requirement - 1",
    desc1:
      "Lorem is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries.",
    controlTitle: "Control - 1",
    desc2:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries.",
  },
  {
    requirementTitle: "Requirement - 1",
    desc1:
      "Lorem is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries.",
    controlTitle: "Control - 1",
    desc2:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries.",
  },
  {
    requirementTitle: "Requirement - 1",
    desc1:
      "Lorem is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries.",
    controlTitle: "Control - 1",
    desc2:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries.",
  },
  {
    requirementTitle: "Requirement - 1",
    desc1:
      "Lorem is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries.",
    controlTitle: "Control - 1",
    desc2:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries.",
  },
];

const TABLE_HEAD = [
  "Name",
  "Description",
  "Status",
  "Standard",
  "Start Date",
  "End Date",
  "Created By",
  "Assigned To",
  "Approved By",
  "Action",
];

export default function Audit() {
  const { completeAuthData: authData, refreshToken, rbac } = useAuthUserToken();
  const [templateData, setTemplateData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [isLoading, setIsLoading] = useState(null);
  const [searchBy, setSearchBy] = useState("");
  const [sortBy, setSortBy] = useState("asc");
  const [status, setStatus] = useState("");
  const [standard, setStandard] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [errors, setErrors] = useState({ name: "" });
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [reloadData, setReloadData] = useState(false);
  const [dataToSend, setDataToSend] = useState({});
  const [id, setId] = useState("");
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const [isStandardLoading, setisStandardLoading] = useState(null);
  const [standardValue, setStandardValue] = useState("");
  const [pcidssData, setPcidssData] = useState([]);
  const [pcidssV4Data, setPcidssV4Data] = useState([]);

  const [editStandardValue, SetEditStandardValue] = useState("");
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState(
    Array(TABLE_ROWS_CONTROL.length).fill(false)
  );

  const handleOpenCreateDialog = () => {
    setOpenCreateDialog((cur) => !cur);
  };

  const [open, setOpen] = useState(false);
  const handleOpen = (item) => {
    setFormData({
      auditName: item?.auditName || "",
      auditDescription: item?.auditDescription || "",
      auditStartDate: item?.auditStartDate || "",
      auditEndDate: item?.auditEndDate || "",
      auditStatus: item?.auditStatus || "",
      auditStandard: item?.auditStandard || "",
      auditStandardCheck: item?.auditStandardCheck || [],
      auditAssignee: item?.auditAssignee ?? "",
      auditApprover: item?.auditApprover || "",
    });
    SetEditStandardValue(item?.auditStandard);
    setId(item?._id || "");
    setErrors({ name: "" });
    setOpen((cur) => !cur);
  };

  useEffect(() => {
    getAuditData(
      refreshToken,
      searchBy,
      sortBy,
      limit,
      page,
      status,
      standard
    ).then((data) => {
      if (data?.code === 403) {
        navigate('/403');
        toast.error(data?.message, {
          className: "text-[12px]",
        });
      }
      if (data?.code === 440)
        toast.error(data?.message, {
          className: "text-[12px]",
        });
      setTotalPage(data?.data?.totalPages);
      setTemplateData(data?.data?.results);
      setIsLoading(false);
    });
    if (userData.length === 0) {
      getUserData(refreshToken, "", "asc", 100, 1, "").then((data) => {
        setUserData(data?.data?.results);
      });
    }
  }, [page, limit, sortBy, searchBy, status, standard, reloadData, refreshToken, userData]);

  // Create Form Functionality

  const formSetData = {
    auditName: "",
    auditDescription: "",
    auditStartDate: "",
    auditEndDate: "",
    auditStatus: "",
    auditStandard: "",
    auditApprover: "",
    auditAssignee: "",
    auditStandardCheck: [],
  };

  const [formData, setFormData] = useState(formSetData);

  useEffect(() => {
    setDataToSend({
      auditName: formData?.auditName ?? "",
      auditDescription: formData?.auditDescription ?? "",
      auditStartDate: formData.auditStartDate ?? "",
      auditEndDate: formData.auditEndDate ?? "",
      auditStatus: formData.auditStatus ?? "",
      auditStandard: formData.auditStandard ?? "",
      auditAssignee: formData.auditAssignee ?? "",
      auditApprover: formData.auditApprover ?? "",
      auditStandardCheck: formData.auditStandardCheck ?? [],
    });
  }, [
    formData.auditName,
    formData.auditDescription,
    formData.auditStartDate,
    formData.auditEndDate,
    formData.auditStatus,
    formData.auditStandard,
    formData.auditApprover,
    formData.auditAssignee,
    formData.auditStandardCheck,
  ]);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.auditName.trim()) newErrors.auditName = "Name is required";
    if (!formData.auditDescription.trim())
      newErrors.auditDescription = "Description is required";
    if (!formData.auditStartDate.trim())
      newErrors.auditStartDate = "Start Date is required";
    if (!formData.auditEndDate.trim())
      newErrors.auditEndDate = "End Date is required";
    if (!formData.auditStatus.trim())
      newErrors.auditStatus = "Audit Status is required";
    if (!formData.auditStandard.trim())
      newErrors.auditStandard = "Audit Standard is required";
    if (!formData.auditAssignee.trim())
      newErrors.auditAssignee = "Assignee is required";
    if (!formData.auditApprover.trim())
      newErrors.auditApprover = "Approver is required";
    if (
      Date.parse(formData.auditStartDate) >= Date.parse(formData.auditEndDate)
    ) {
      newErrors.auditEndDate =
        "End Date not be less than or equal to Start Date";
    }
    setErrors(newErrors);
  };

  const validateEditForm = () => {
    const newErrors = {};
    if (!formData.auditName.trim()) newErrors.auditName = "Name is required";
    if (!formData.auditDescription.trim())
      newErrors.auditDescription = "Description is required";
    if (!formData.auditStartDate.trim())
      newErrors.auditStartDate = "Start Date is required";
    if (!formData.auditEndDate.trim())
      newErrors.auditEndDate = "End Date is required";
    if (!formData.auditStatus.trim())
      newErrors.auditStatus = "Audit Status is required";
    if (!formData.auditAssignee.trim())
      newErrors.auditAssignee = "Assignee is required";
    if (!formData.auditApprover.trim())
      newErrors.auditApprover = "Approver is required";
    if (
      Date.parse(formData.auditStartDate) >= Date.parse(formData.auditEndDate)
    ) {
      newErrors.auditEndDate =
        "End Date not be less than or equal to Start Date";
    }
    setErrors(newErrors);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleChangeSelect = (e, fieldName) => {
    setStandardValue(e);
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: e,
    }));
  };

  const handleBlur = () => {
    validateForm();
  };

  const handleNext = () => {
    validateForm();
    if (Object.keys(errors).length === 0)
      setActiveStep((prevStep) => prevStep + 1);
  };

  const handleEditNext = () => {
    validateEditForm();
    if (Object.keys(errors).length === 0)
      setActiveStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const handleEditBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const handleSelectAll = (e) => {
    const updatedSelectedRows = {};
    setFormData((oldData) => ({
      ...oldData,
      auditStandardCheck: [],
    }));
    setSelectAll((prevSelectAll) => !prevSelectAll);
    if (standardValue === "PCI DSS v3.2.1") {
      pcidssData.map(({ _id }) => {
        if (e.target.checked) {
          setFormData((oldData) => ({
            ...oldData,
            auditStandardCheck: [...oldData.auditStandardCheck, _id],
          }));
        }
        updatedSelectedRows[_id] = !selectAll;
        return null;
      });
    } else if (standardValue === "PCI DSS v4.0") {
      pcidssV4Data.map(({ _id }) => {
        if (e.target.checked) {
          setFormData((oldData) => ({
            ...oldData,
            auditStandardCheck: [...oldData.auditStandardCheck, _id],
          }));
        }
        updatedSelectedRows[_id] = !selectAll;
        return null;
      });
    }
    setSelectedRows(updatedSelectedRows);
  };

  const handleEditSelectAll = (e) => {
    // Toggle the selectAll state
    setSelectAll((prevSelectAll) => !prevSelectAll);

    // Update the auditStandardCheck array in the formData state
    const updatedFormData = {
      ...formData,
      auditStandardCheck: e.target.checked
        ? pcidssData.map(({ _id }) => _id)
        : [],
    };
    setFormData(updatedFormData);

    // Update the selectedRows state if needed
    const updatedSelectedRows = {};
    if (e.target.checked) {
      pcidssData.forEach(({ _id }) => {
        updatedSelectedRows[_id] = true;
      });
    }
    setSelectedRows(updatedSelectedRows);
  };

  const handleRowCheckboxChange = (_id, e) => {
    if (e.target.checked) {
      setFormData((oldData) => ({
        ...oldData,
        auditStandardCheck: [...oldData.auditStandardCheck, _id],
      }));
    } else {
      setFormData((oldData) => ({
        ...oldData,
        auditStandardCheck: oldData.auditStandardCheck.filter(
          (id) => id !== _id
        ),
      }));
    }

    setSelectedRows((prevSelectedRows) => ({
      ...prevSelectedRows,
      [_id]: !prevSelectedRows[_id],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoadingButton(true);
    validateForm();
    if (Object.keys(errors).length === 0) {
      createAuditData(refreshToken, dataToSend)
        .then((response) => {
          if (response?.code === 200 || response?.code === 201) {
            toast.success("Audit created successfully", {
              className: "text-[12px]",
            });
          } else if (response.code === 400 || response?.code === 401) {
            toast.error(response?.message, {
              className: "text-[12px]",
            });
          } else {
            toast.error(response?.message, {
              className: "text-[12px]",
            });
          }
        })
        .catch((error) => {
          toast.error("Something went wrong!", {
            className: "text-[12px]",
          });
          console.error("Error during login:", error);
        })
        .finally(() => {
          setActiveStep(0);
          setIsLoadingButton(false);
          setFormData(formSetData);
          setErrors({ name: "" });
          setOpenCreateDialog((cur) => !cur);
          setReloadData((cur) => !cur);
        });
    } else {
      setIsLoadingButton(false);
    }
  };

  const handleEdit = async (e) => {
    e.preventDefault();
    setIsLoadingButton(true);
    validateEditForm();
    if (Object.keys(errors).length === 0) {
      editAuditData(refreshToken, formData, id)
        .then((response) => {
          if (response?.code === 200 || response?.code === 201) {
            toast.success("Audit Data updated successfully", {
              className: "text-[12px]",
            });
          } else if (response?.code === 400 || response?.code === 401) {
            toast.error(response?.message, {
              className: "text-[12px]",
            });
          } else {
            toast.error(response?.message, {
              className: "text-[12px]",
            });
          }
        })
        .catch((error) => {
          toast.error("Something went wrong!", {
            className: "text-[12px]",
          });
          console.error("Error during login:", error);
        })
        .finally(() => {
          setActiveStep(0);
          setFormData(formSetData);
          setIsLoadingButton(false);
          setOpen((cur) => !cur);
          setReloadData((cur) => !cur);
        });
    } else {
      setIsLoadingButton(false);
    }
  };

  const exportToExcel = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Audit Data");
    const headers = [
      "S.No.",
      "Id",
      "Name",
      "Description",
      "Status",
      "Standard",
      "Start Date",
      "End Date",
      "Created By",
      "Assigned To",
      "Approved By",
    ];
    worksheet.addRow(headers);
    templateData.forEach((row, index) => {
      worksheet.addRow([
        index + 1,
        row._id,
        row.auditName,
        row.auditDescription,
        row.auditStatus,
        row.auditStandard,
        row.auditStartDate,
        row.auditEndDate,
        authData.fullName,
        row.auditAssignee,
        row.auditApprover,
      ]);
    });
    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "audit_data.xlsx";
      a.click();
      URL.revokeObjectURL(url);
    });
  };

  // fetch standardValue data useeffect
  useEffect(() => {
    setisStandardLoading(null);
    if (
      standardValue === "PCI DSS v3.2.1" ||
      editStandardValue === "PCI DSS v3.2.1"
    ) {
      getPcidssv321Data(
        refreshToken,
        searchBy,
        sortBy,
        limit,
        page,
        status,
        standard
      ).then((data) => {
        if (data?.code === 440)
          toast.error(data?.message, {
            className: "text-[12px]",
          });
        setPcidssData(data?.data);
        setisStandardLoading(false);
      });
    } else if (
      standardValue === "PCI DSS v4.0" ||
      editStandardValue === "PCI DSS v4.0"
    ) {
      getPcidssv4Data(
        refreshToken,
        searchBy,
        sortBy,
        limit,
        page,
        status,
        standard
      ).then((data) => {
        if (data?.code === 440)
          toast.error(data?.message, {
            className: "text-[12px]",
          });
        setPcidssV4Data(data?.data);
        setisStandardLoading(false);
      });
    } else {
      setisStandardLoading(false);
    }
  }, [standardValue, editStandardValue, refreshToken, searchBy, sortBy, limit, page, status, standard]);

  return (
    <div className="app-main__inner !pl-20 ">
      {/* Table Card Start */}
      <Card
        className="h-full w-full rounded-3xl shadow-xl"
        style={{ backgroundImage: `url('/assets/images/beams.jpg')` }}
      >
        <CardHeader
          floated={false}
          shadow={false}
          className=" bg-transparent rounded-none !overflow-visible"
        >
          <div className="mb-8 flex flex-col md:flex-row md:items-center md:justify-between md:gap-8">
            <div>
              <Typography variant="h5" color="blue-gray">
                List of Audits
              </Typography>
              <Typography color="gray" className="mt-1 font-normal">
                View all completed, ongoing and scheduled audits
              </Typography>
            </div>
            <div className="flex flex-row md:flex-row items-center justify-between md:items-center gap-2 md:gap-8 mt-4 md:mt-0">
              <Button
                variant="outlined"
                size="sm"
                onClick={exportToExcel}
                loading={isLoading === null ? true : false}
              >
                <ArrowDownIcon strokeWidth={2} className="h-4 w-4" />
              </Button>
              {rbac?.auditAdd ? (
                <>
                  <Button
                    onClick={handleOpenCreateDialog}
                    className="flex items-center gap-3"
                    size="sm"
                    loading={isLoading === null ? true : false}
                  >
                    <UserPlusIcon strokeWidth={2} className="h-4 w-4" />
                    <span className="hidden md:inline-block"> Create New</span>
                  </Button>
                </>
              ) : null}
            </div>
          </div>
          <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 w-full">
              <Select
                color="blue"
                label="Select Limit"
                className="!border-t-0 !border-[#b0bec5]"
                onChange={(event) => {
                  setLimit(event);
                  setIsLoading(null);
                }}
                value={limit}
              >
                <Option value={10}>10</Option>
                <Option value={20}>20</Option>
                <Option value={30}>30</Option>
                <Option value={40}>40</Option>
                <Option value={50}>50</Option>
              </Select>
              <Select
                color="purple"
                label="Sort By"
                className="!border-t-0 !border-[#b0bec5]"
                onChange={(event) => {
                  setSortBy(event);
                  setIsLoading(null);
                }}
                value={sortBy}
              >
                <Option value="asc">Ascending</Option>
                <Option value="desc">Descending</Option>
              </Select>
              <Select
                color="green"
                label="Standard"
                className="!border-t-0 !border-[#b0bec5]"
                onChange={(event) => {
                  setStandard(event);
                  setIsLoading(null);
                }}
                value={standard}
              >
                <Option value="">Select Standard</Option>
                <Option value="PCI DSS v3.2.1">PCI DSS v3.2.1</Option>
                <Option value="PCI DSS v4.0">PCI DSS v4.0</Option>
              </Select>
              <Select
                color="yellow"
                label="Status"
                className="!border-t-0 !border-[#b0bec5]"
                onChange={(event) => {
                  setStatus(event);
                  setIsLoading(null);
                }}
                value={status}
              >
                <Option value="">Select Status</Option>
                <Option value="scheduled">Schedule</Option>
                <Option value="inProgress">In Progress</Option>
                <Option value="completed">Completed</Option>
                <Option value="onHold">On Hold</Option>
                <Option value="cancelled">Cancelled</Option>
              </Select>
            </div>
            <div className="w-full md:w-auto">
              <Input
                label="Search"
                value={searchBy}
                className="focus:!border-black focus:!border-2 focus:!border-t-0"
                onChange={(e) => setSearchBy(e.target.value)}
                icon={<MagnifyingGlassIcon className="h-5 w-5" />}
              />
            </div>
          </div>
        </CardHeader>
        <CardBody className="overflow-scroll px-3 p-0">
          <table className="mt-4 w-full min-w-max table-auto text-left">
            <thead>
              <tr>
                {TABLE_HEAD.map((head, index) => (
                  <th
                    key={head}
                    className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-3 transition-colors hover:bg-blue-gray-50 w-32"
                  >
                    <Typography
                      variant="small"
                      color="blue-gray"
                      className="flex items-center justify-between gap-2 font-bold leading-none opacity-70"
                    >
                      {head}{" "}
                      {index !== TABLE_HEAD.length - 1 && (
                        <ChevronUpDownIcon
                          strokeWidth={2}
                          className="h-4 w-4"
                        />
                      )}
                    </Typography>
                  </th>
                ))}
              </tr>
            </thead>
            {isLoading === null ? (
              <>
                <tbody>
                  <tr>
                    <td colSpan={TABLE_HEAD.length}>
                      <TableSkeleton />
                    </td>
                  </tr>
                </tbody>
              </>
            ) : (
              <>
                <tbody>
                  {isLoading === false && templateData?.length > 0 ? (
                    templateData.map(
                      (
                        {
                          auditName,
                          auditDescription,
                          auditStatus,
                          auditStandard,
                          auditStartDate,
                          auditEndDate,
                          auditApprover,
                          auditStandardCheck,
                          auditAssignee,
                          _id,
                        },
                        index
                      ) => {
                        const isLast = index === templateData.length - 1;
                        const classes = isLast
                          ? "p-3"
                          : "p-3 border-b border-blue-gray-50";

                        return (
                          <tr key={`${_id}-${index}`}>
                            <td className={classes}>
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal"
                              >
                                {auditName}
                              </Typography>
                            </td>
                            <td className={classes}>
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal capitalize"
                              >
                                {auditDescription &&
                                  auditDescription.length > 40 ? (
                                  <TableRowWithShowMore
                                    data={auditDescription}
                                  />
                                ) : (
                                  auditDescription
                                )}
                              </Typography>
                            </td>
                            <td className={classes}>
                              <div className="w-max">
                                <Chip
                                  variant="ghost"
                                  size="sm"
                                  value={
                                    auditStatus === "schedule"
                                      ? "Schedule"
                                      : auditStatus === "inProgress"
                                        ? "In Progress"
                                        : auditStatus === "completed"
                                          ? "Completed"
                                          : auditStatus === "onHold"
                                            ? "On Hold"
                                            : auditStatus === "cancelled"
                                              ? "Cancelled"
                                              : "None"
                                  }
                                  color={
                                    auditStatus === "schedule"
                                      ? "blue"
                                      : auditStatus === "inProgress"
                                        ? "yellow"
                                        : auditStatus === "completed"
                                          ? "green"
                                          : auditStatus === "onHold"
                                            ? "orange"
                                            : auditStatus === "cancelled"
                                              ? "red"
                                              : "blue-gray"
                                  }
                                />
                              </div>
                            </td>
                            <td className={classes}>
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal"
                              >
                                {auditStandard}
                              </Typography>
                            </td>
                            <td className={classes}>
                              <Chip
                                variant="ghost"
                                size="sm"
                                value={
                                  auditStartDate
                                    ? moment(auditStartDate).format(
                                      "MMMM DD, YYYY"
                                    )
                                    : ""
                                }
                                className="rounded-full w-fit text-xs	normal-case font-medium	"
                              />
                            </td>
                            <td className={classes}>
                              <Chip
                                variant="ghost"
                                size="sm"
                                value={
                                  auditEndDate
                                    ? moment(auditEndDate).format(
                                      "MMMM DD, YYYY"
                                    )
                                    : ""
                                }
                                className="rounded-full w-fit text-xs	normal-case font-medium	"
                              />
                            </td>
                            <td className={classes}>
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal"
                              >
                                {authData.fullName}
                              </Typography>
                            </td>
                            <td className={classes}>
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal"
                              >
                                {auditAssignee}
                              </Typography>
                            </td>
                            <td className={classes}>
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal"
                              >
                                {auditApprover}
                              </Typography>
                            </td>
                            {rbac?.auditEdit ? (
                              <>
                                <td className={classes}>
                                  <Tooltip
                                    className="bg-blue-gray-500"
                                    content="Edit"
                                  >
                                    <IconButton
                                      variant="text"
                                      onClick={() =>
                                        handleOpen({
                                          auditName,
                                          auditDescription,
                                          auditStartDate,
                                          auditEndDate,
                                          auditApprover,
                                          auditStandardCheck,
                                          auditStandard,
                                          auditAssignee,
                                          auditStatus,
                                          _id,
                                        })
                                      }
                                    >
                                      <PencilIcon className="h-4 w-4" />
                                    </IconButton>
                                  </Tooltip>
                                </td>
                              </>
                            ) : <td></td>}
                          </tr>
                        );
                      }
                    )
                  ) : (
                    <tr>
                      <td colSpan="8">
                        <div className="flex flex-col items-center w-full">
                          <img
                            quality={100}
                            src="/assets/images/9276430.jpg"
                            className="w-[350px] mix-blend-darken"
                            alt="no-data-found"
                          />
                          <p className="text-[20px] font-medium">
                            No Data Found!
                          </p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </>
            )}
          </table>
        </CardBody>
        {isLoading === null ? null : (
          <>
            <CardFooter className="flex items-center justify-between border-t border-blue-gray-50 p-4">
              <Button
                variant="outlined"
                size="sm"
                onClick={() => {
                  setIsLoading(null);
                  setPage(page - 1);
                }}
                disabled={totalPage > 1 ? false : true}
              >
                Previous
              </Button>
              <div className="flex items-center gap-2">
                {Array.from({ length: totalPage }, (_, index) => (
                  <IconButton
                    key={index + 1}
                    variant={index + 1 === page ? "outlined" : "text"}
                    size="sm"
                    onClick={() => {
                      setIsLoading(null);
                      setPage(index + 1);
                    }}
                    disabled={totalPage > 1 ? false : true}
                  >
                    {index + 1}
                  </IconButton>
                ))
                  .reduce((acc, button, index, array) => {
                    if (
                      index < 3 ||
                      index >= totalPage - 3 ||
                      (index >= Math.max(page - 1, 3) &&
                        index <= Math.min(page + 1, totalPage - 4))
                    ) {
                      acc.push(button);
                    } else if (acc[acc.length - 1] !== "ellipsis") {
                      acc.push("ellipsis");
                    }
                    return acc;
                  }, [])
                  .map((element, index, array) => {
                    return element === "ellipsis" ? (
                      <IconButton
                        key={`ellipsis-${index}`}
                        variant="text"
                        size="sm"
                        disabled
                      >
                        ...
                      </IconButton>
                    ) : index > 0 && array[index - 1] === "ellipsis" ? (
                      <React.Fragment key={`fragment-${index}`}>
                        {element}
                      </React.Fragment>
                    ) : (
                      element
                    );
                  })}
              </div>

              <Button
                variant="outlined"
                size="sm"
                onClick={() => {
                  setIsLoading(null);
                  setPage(page + 1);
                }}
                disabled={totalPage > 1 ? false : true}
              >
                Next
              </Button>
            </CardFooter>
          </>
        )}
      </Card>
      {/* Table Card End */}

      {/* Edit Dailog Box Start*/}
      <Dialog
        size="lg"
        open={open}
        handler={handleOpen}
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
      >
        <form onSubmit={handleEdit}>
          <Card className="mx-auto w-full">
            <CardBody className="flex flex-col gap-4">
              {activeStep === 0 && (
                <>
                  <Typography variant="h4" color="blue-gray">
                    Edit | Audit
                  </Typography>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <Typography className="mb-1 " variant="h6">
                        Name
                      </Typography>
                      <Input
                        type="text"
                        label="Name"
                        size="lg"
                        name="auditName"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={formData?.auditName}
                        className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                      />
                      {errors.auditName && (
                        <p className="text-red-900 text-[12px]">
                          {errors.auditName}
                        </p>
                      )}
                    </div>
                    <div>
                      <Typography className="mb-1 " variant="h6">
                        Description
                      </Typography>
                      <Input
                        type="text"
                        label="Description"
                        size="lg"
                        name="auditDescription"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={formData?.auditDescription}
                        className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                      />
                      {errors.auditDescription && (
                        <p className="text-red-900 text-[12px]">
                          {errors.auditDescription}
                        </p>
                      )}
                    </div>
                    <div>
                      <Typography className="mb-1 " variant="h6">
                        Start Date
                      </Typography>
                      <Input
                        type="date"
                        name="auditStartDate"
                        label="Start Time"
                        size="lg"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={formData?.auditStartDate}
                        className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                      />
                      {errors.auditStartDate && (
                        <p className="text-red-900 text-[12px]">
                          {errors.auditStartDate}
                        </p>
                      )}
                    </div>
                    <div>
                      <Typography className="mb-1 " variant="h6">
                        End Date
                      </Typography>
                      <Input
                        type="date"
                        name="auditEndDate"
                        label="Start Time"
                        size="lg"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={formData?.auditEndDate}
                        className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                      />
                      {errors.auditEndDate && (
                        <p className="text-red-900 text-[12px]">
                          {errors.auditEndDate}
                        </p>
                      )}
                    </div>
                    <div>
                      <Typography className="mb-1 " variant="h6">
                        Audit Status
                      </Typography>
                      <Select
                        label="Status"
                        color="purple"
                        name="auditStatus"
                        onChange={(e) => handleChangeSelect(e, "auditStatus")}
                        onBlur={handleBlur}
                        value={formData?.auditStatus || ""}
                      >
                        <Option value="active">Select Status</Option>
                        <Option value="scheduled">Schedule</Option>
                        <Option value="inProgress">In Progress</Option>
                        <Option value="completed">Completed</Option>
                        <Option value="onHold">On Hold</Option>
                        <Option value="cancelled">Cancelled</Option>
                      </Select>
                      {errors.auditStatus && (
                        <p className="text-red-900 text-[12px]">
                          {errors.auditStatus}
                        </p>
                      )}
                    </div>
                    <div>
                      <Typography className="mb-1 " variant="h6">
                        Standard
                      </Typography>
                      <Select
                        label="Audit Standard"
                        color="purple"
                        name="auditStandard"
                        value={formData?.auditStandard || ""}
                        disabled
                        className="cursor-not-allowed"
                      >
                        <Option value="">Select Standard</Option>
                        <Option value="PCI DSS v3.2.1">PCI DSS v3.2.1</Option>
                        <Option value="PCI DSS v4.0">PCI DSS v4.0</Option>
                      </Select>
                    </div>
                    <div>
                      <Typography className="mb-1" variant="h6">
                        Assignee
                      </Typography>
                      <Select
                        label="Assignee"
                        color="purple"
                        name="auditAssignee"
                        value={formData?.auditAssignee || ""}
                        onBlur={handleBlur}
                        onChange={(e) => handleChangeSelect(e, "auditAssignee")}
                      >
                        {userData.map((resp, index) => (
                          <Option key={index} value={resp?.fullName}>
                            {resp?.fullName}
                          </Option>
                        ))}
                      </Select>
                      {errors.auditAssignee && (
                        <p className="text-red-900 text-[12px]">
                          {errors.auditAssignee}
                        </p>
                      )}
                    </div>
                    <div>
                      <Typography className="mb-1 " variant="h6">
                        Approver
                      </Typography>
                      <Select
                        label="Approver"
                        color="purple"
                        name="userData"
                        value={formData?.auditApprover || ""}
                        onBlur={handleBlur}
                        onChange={(e) => handleChangeSelect(e, "userData")}
                      >
                        {userData.map((resp, index) => (
                          <Option key={index} value={resp?.fullName}>
                            {resp?.fullName}
                          </Option>
                        ))}
                      </Select>
                      {errors.auditApprover && (
                        <p className="text-red-900 text-[12px]">
                          {errors.auditApprover}
                        </p>
                      )}
                    </div>
                  </div>
                </>
              )}

              {activeStep === 1 && (
                <div className="overflow-y-auto max-h-[400px]">
                  <table className="mt-4 w-full min-w-max table-auto text-left">
                    <thead>
                      <tr>
                        {TABLE_HEAD_CONTROL.map((head, index) => (
                          <th
                            key={index}
                            className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-3 transition-colors hover:bg-blue-gray-50 w-16"
                          >
                            {head === "Select button" ? (
                              <div className=" font-normal flex gap-2 items-center">
                                <Checkbox
                                  checked={selectAll}
                                  onChange={(e) => handleEditSelectAll(e)}
                                  ripple={true}
                                  className="!border !border-black"
                                />
                                <Typography
                                  variant="small"
                                  color="blue-gray"
                                  className="font-bold leading-none opacity-70"
                                >
                                  Select All
                                </Typography>
                              </div>
                            ) : (
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="flex items-center justify-between gap-2 font-bold leading-none opacity-70"
                              >
                                {head}{" "}
                              </Typography>
                            )}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {isStandardLoading === null ? (
                        <tr>
                          <td colSpan="5">
                            <div className="animate-pulse space-y-4 mt-2">
                              <div className="w-full h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                              <div className="w-full h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                              <div className="w-full h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                              <div className="w-full h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                              <div className="w-full h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                              <div className="w-full h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                              <div className="w-full h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                              <div className="w-full h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                              <div className="w-full h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                              <div className="w-full h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                            </div>
                          </td>
                        </tr>
                      ) : editStandardValue === "PCI DSS v3.2.1" &&
                        pcidssData &&
                        pcidssData.length > 0 ? (
                        pcidssData.map(
                          (
                            {
                              RequirementID,
                              Requirement,
                              ControlID,
                              ControlDescription,
                              _id,
                            },
                            index,
                            array
                          ) => {
                            const isLast = index === array.length - 1;
                            const classes = isLast
                              ? "p-4"
                              : "p-4 border-b border-blue-gray-50";
                            return (
                              <tr key={index}>
                                <td className={classes}>
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal"
                                  >
                                    {RequirementID}
                                  </Typography>
                                </td>
                                <td className={classes}>
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal"
                                  >
                                    {Requirement.length > 40 ? (
                                      <TableRowWithShowMore
                                        data={Requirement}
                                      />
                                    ) : (
                                      Requirement
                                    )}
                                  </Typography>
                                </td>
                                <td className={classes}>
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal"
                                  >
                                    {ControlID}
                                  </Typography>
                                </td>
                                <td className={classes}>
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal"
                                  >
                                    {ControlDescription.length > 40 ? (
                                      <TableRowWithShowMore
                                        data={ControlDescription}
                                      />
                                    ) : (
                                      ControlDescription
                                    )}
                                  </Typography>
                                </td>
                                <td className={classes}>
                                  <Checkbox
                                    ripple={true}
                                    onChange={(e) =>
                                      handleRowCheckboxChange(_id, e)
                                    }
                                    checked={formData.auditStandardCheck.includes(
                                      _id
                                    )}
                                    className="!border !border-black"
                                  />
                                </td>
                              </tr>
                            );
                          }
                        )
                      ) : editStandardValue === "PCI DSS v4.0" &&
                        pcidssV4Data &&
                        pcidssV4Data.length > 0 ? (
                        pcidssV4Data.map(
                          (
                            {
                              RequirementID,
                              Requirement,
                              ControlID,
                              ControlDescription,
                              _id,
                            },
                            index,
                            array
                          ) => {
                            const isLast = index === array.length - 1;
                            const classes = isLast
                              ? "p-4"
                              : "p-4 border-b border-blue-gray-50";

                            return (
                              <tr key={index}>
                                <td className={classes}>
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal"
                                  >
                                    {RequirementID}
                                  </Typography>
                                </td>
                                <td className={classes}>
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal"
                                  >
                                    {Requirement.length > 40 ? (
                                      <TableRowWithShowMore
                                        data={Requirement}
                                      />
                                    ) : (
                                      Requirement
                                    )}
                                  </Typography>
                                </td>
                                <td className={classes}>
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal"
                                  >
                                    {ControlID}
                                  </Typography>
                                </td>
                                <td className={classes}>
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal"
                                  >
                                    {ControlDescription.length > 40 ? (
                                      <TableRowWithShowMore
                                        data={ControlDescription}
                                      />
                                    ) : (
                                      ControlDescription
                                    )}
                                  </Typography>
                                </td>
                                <td className={classes}>
                                  <Checkbox
                                    ripple={true}
                                    onChange={(e) =>
                                      handleRowCheckboxChange(_id, e)
                                    }
                                    checked={selectedRows[_id] || false}
                                    className="!border !border-black"
                                  />
                                </td>
                              </tr>
                            );
                          }
                        )
                      ) : (
                        <tr>
                          <td colSpan="8">
                            <div className="flex flex-col items-center w-full">
                              <img
                                height={250}
                                width={250}
                                quality={100}
                                src="/assets/images/no-data-found.png"
                                className="w-1/4 mix-blend-darken"
                                alt=""
                              />
                              <p className="text-[18px] font-extralight">
                                No Data Found!
                              </p>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </CardBody>
            <CardFooter className="flex justify-end border-t-2 py-2">
              {activeStep === 0 && (
                <>
                  <Button
                    variant="text"
                    color="red"
                    onClick={handleOpen}
                    className="mr-1"
                  >
                    <span>Cancel</span>
                  </Button>
                  <Button
                    variant="gradient"
                    color="green"
                    onClick={handleEditNext}
                  // disabled={activeNextStep}
                  >
                    <span>Next</span>
                  </Button>
                </>
              )}

              {activeStep === 1 && (
                <>
                  <Button
                    variant="text"
                    color="red"
                    onClick={handleEditBack}
                    className="mr-1"
                  >
                    <span>Back</span>
                  </Button>
                  <Button
                    variant="gradient"
                    color="green"
                    type="submit"
                    loading={isLoadingButton ? true : false}
                  >
                    <span>Submit</span>
                  </Button>
                </>
              )}
            </CardFooter>
          </Card>
        </form>
      </Dialog>
      {/* Edit Dailog Box End*/}

      {/* Create new Dailog Box Start */}
      <Dialog
        size="lg"
        open={openCreateDialog}
        handler={() => setOpenCreateDialog(false)}
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
      >
        <form onSubmit={handleSubmit}>
          <Card className="mx-auto w-full">
            <CardBody className="flex flex-col gap-4">
              {activeStep === 0 && (
                <>
                  <Typography variant="h4" color="blue-gray">
                    Add | Audit
                  </Typography>

                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <Typography className="mb-1 " variant="h6">
                        Name
                      </Typography>
                      <Input
                        type="text"
                        label="Audit Name"
                        size="lg"
                        name="auditName"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={formData?.auditName}
                        className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                      />
                      {errors.auditName && (
                        <p className="text-red-900 text-[12px]">
                          {errors.auditName}
                        </p>
                      )}
                    </div>
                    <div>
                      <Typography className="mb-1 " variant="h6">
                        Description
                      </Typography>
                      <Input
                        type="text"
                        label="Audit Description"
                        size="lg"
                        name="auditDescription"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={formData?.auditDescription}
                        className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                      />
                      {errors.auditDescription && (
                        <p className="text-red-900 text-[12px]">
                          {errors.auditDescription}
                        </p>
                      )}
                    </div>
                    <div>
                      <Typography className="mb-1 " variant="h6">
                        Start Date
                      </Typography>
                      <Input
                        type="date"
                        name="auditStartDate"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label="Start Date"
                        size="lg"
                        value={formData?.auditStartDate}
                        className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                      />
                      {errors.auditStartDate && (
                        <p className="text-red-900 text-[12px]">
                          {errors.auditStartDate}
                        </p>
                      )}
                    </div>
                    <div>
                      <Typography className="mb-1 " variant="h6">
                        End Date
                      </Typography>
                      <Input
                        type="date"
                        name="auditEndDate"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label="End Date"
                        size="lg"
                        value={formData?.auditEndDate}
                        className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                      />
                      {errors.auditEndDate && (
                        <p className="text-red-900 text-[12px]">
                          {errors.auditEndDate}
                        </p>
                      )}
                    </div>
                    <div>
                      <Typography className="mb-1 " variant="h6">
                        Audit Status
                      </Typography>
                      <Select
                        label="Audit Status"
                        onChange={(e) => handleChangeSelect(e, "auditStatus")}
                        onBlur={handleBlur}
                        name="auditStatus"
                        color="purple"
                        value={formData?.auditStatus}
                      >
                        <Option value="">Select Status</Option>
                        <Option value="scheduled">Schedule</Option>
                        <Option value="inProgress">In Progress</Option>
                        <Option value="completed">Completed</Option>
                        <Option value="onHold">On Hold</Option>
                        <Option value="cancelled">Cancelled</Option>
                      </Select>
                      {errors.auditStatus && (
                        <p className="text-red-900 text-[12px]">
                          {errors.auditStatus}
                        </p>
                      )}
                    </div>
                    <div>
                      <Typography className="mb-1" variant="h6">
                        Standard
                      </Typography>
                      <Select
                        label="Audit Standard"
                        onChange={(e) => {
                          handleChangeSelect(e, "auditStandard");
                        }}
                        onBlur={handleBlur}
                        name="auditStandard"
                        color="purple"
                        value={formData?.auditStandard}
                      >
                        <Option value="">Select Standard</Option>
                        <Option value="PCI DSS v3.2.1">PCI DSS v3.2.1</Option>
                        <Option value="PCI DSS v4.0">PCI DSS v4.0</Option>
                      </Select>
                      {errors.auditStandard && (
                        <p className="text-red-900 text-[12px]">
                          {errors.auditStandard}
                        </p>
                      )}
                    </div>
                    <div>
                      <Typography className="mb-1 " variant="h6">
                        Assignee
                      </Typography>
                      <Select
                        label="Assignee"
                        color="purple"
                        name="auditAssignee"
                        onBlur={handleBlur}
                        onChange={(e) => handleChangeSelect(e, "auditAssignee")}
                        value={formData?.auditAssignee}
                      >
                        {userData.map((resp, index) => (
                          <Option key={index} value={resp?.fullName}>
                            {resp?.fullName}
                          </Option>
                        ))}
                      </Select>
                      {errors.auditAssignee && (
                        <p className="text-red-900 text-[12px]">
                          {errors.auditAssignee}
                        </p>
                      )}
                    </div>
                    <div>
                      <Typography className="mb-1 " variant="h6">
                        Approver
                      </Typography>
                      <Select
                        label="Approver"
                        color="purple"
                        name="auditApprover"
                        onBlur={handleBlur}
                        onChange={(e) => handleChangeSelect(e, "auditApprover")}
                        value={formData?.auditApprover}
                      >
                        {userData.map((resp, index) => (
                          <Option key={index} value={resp?.fullName}>
                            {resp?.fullName}
                          </Option>
                        ))}
                      </Select>
                      {errors.auditApprover && (
                        <p className="text-red-900 text-[12px]">
                          {errors.auditApprover}
                        </p>
                      )}
                    </div>
                  </div>
                </>
              )}

              {activeStep === 1 && (
                <div className="overflow-y-auto max-h-[400px]">
                  <table className="mt-4 w-full min-w-max table-auto text-left">
                    <thead>
                      <tr>
                        {TABLE_HEAD_CONTROL.map((head, index) => (
                          <th
                            key={index}
                            className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-3 transition-colors hover:bg-blue-gray-50 w-16"
                          >
                            {head === "Select button" ? (
                              <div className=" font-normal flex gap-2 items-center">
                                <Checkbox
                                  checked={selectAll}
                                  onChange={(e) => handleSelectAll(e)}
                                  ripple={true}
                                  className="!border !border-black"
                                />
                                <Typography
                                  variant="small"
                                  color="blue-gray"
                                  className="font-bold leading-none opacity-70"
                                >
                                  Select All
                                </Typography>
                              </div>
                            ) : (
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="flex items-center justify-between gap-2 font-bold leading-none opacity-70"
                              >
                                {head}{" "}
                              </Typography>
                            )}
                          </th>
                        ))}
                      </tr>
                    </thead>

                    <tbody>
                      {isStandardLoading === null ? (
                        <tr>
                          <td colSpan="5">
                            <div className="animate-pulse space-y-4 mt-2">
                              <div className="w-full h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                              <div className="w-full h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                              <div className="w-full h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                              <div className="w-full h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                              <div className="w-full h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                              <div className="w-full h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                              <div className="w-full h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                              <div className="w-full h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                              <div className="w-full h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                              <div className="w-full h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                            </div>
                          </td>
                        </tr>
                      ) : standardValue === "PCI DSS v3.2.1" &&
                        pcidssData &&
                        pcidssData.length > 0 ? (
                        pcidssData.map(
                          (
                            {
                              RequirementID,
                              Requirement,
                              ControlID,
                              ControlDescription,
                              _id,
                            },
                            index,
                            array
                          ) => {
                            const isLast = index === array.length - 1;
                            const classes = isLast
                              ? "p-4"
                              : "p-4 border-b border-blue-gray-50";

                            return (
                              <tr key={index}>
                                <td className={classes}>
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal"
                                  >
                                    {RequirementID}
                                  </Typography>
                                </td>
                                <td className={classes}>
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal"
                                  >
                                    {Requirement.length > 40 ? (
                                      <TableRowWithShowMore
                                        data={Requirement}
                                      />
                                    ) : (
                                      Requirement
                                    )}
                                  </Typography>
                                </td>
                                <td className={classes}>
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal"
                                  >
                                    {ControlID}
                                  </Typography>
                                </td>
                                <td className={classes}>
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal"
                                  >
                                    {ControlDescription.length > 40 ? (
                                      <TableRowWithShowMore
                                        data={ControlDescription}
                                      />
                                    ) : (
                                      ControlDescription
                                    )}
                                  </Typography>
                                </td>
                                <td className={classes}>
                                  <Checkbox
                                    ripple={true}
                                    onChange={(e) =>
                                      handleRowCheckboxChange(_id, e)
                                    }
                                    checked={selectedRows[_id] || false}
                                    className="!border !border-black"
                                  />
                                </td>
                              </tr>
                            );
                          }
                        )
                      ) : standardValue === "PCI DSS v4.0" &&
                        pcidssV4Data &&
                        pcidssV4Data.length > 0 ? (
                        pcidssV4Data.map(
                          (
                            {
                              RequirementID,
                              Requirement,
                              ControlID,
                              ControlDescription,
                              _id,
                            },
                            index,
                            array
                          ) => {
                            const isLast = index === array.length - 1;
                            const classes = isLast
                              ? "p-4"
                              : "p-4 border-b border-blue-gray-50";

                            return (
                              <tr key={index}>
                                <td className={classes}>
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal"
                                  >
                                    {RequirementID}
                                  </Typography>
                                </td>
                                <td className={classes}>
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal"
                                  >
                                    {Requirement.length > 40 ? (
                                      <TableRowWithShowMore
                                        data={Requirement}
                                      />
                                    ) : (
                                      Requirement
                                    )}
                                  </Typography>
                                </td>
                                <td className={classes}>
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal"
                                  >
                                    {ControlID}
                                  </Typography>
                                </td>
                                <td className={classes}>
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal"
                                  >
                                    {ControlDescription.length > 40 ? (
                                      <TableRowWithShowMore
                                        data={ControlDescription}
                                      />
                                    ) : (
                                      ControlDescription
                                    )}
                                  </Typography>
                                </td>
                                <td className={classes}>
                                  <Checkbox
                                    ripple={true}
                                    onChange={(e) =>
                                      handleRowCheckboxChange(_id, e)
                                    }
                                    checked={selectedRows[_id] || false}
                                    className="!border !border-black"
                                  />
                                </td>
                              </tr>
                            );
                          }
                        )
                      ) : (
                        <tr>
                          <td colSpan="8">
                            <div className="flex flex-col items-center w-full">
                              <img
                                height={250}
                                width={250}
                                quality={100}
                                src="/assets/images/no-data-found.png"
                                className="w-1/4 mix-blend-darken"
                                alt=""
                              />
                              <p className="text-[18px] font-extralight">
                                No Data Found!
                              </p>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </CardBody>
            <CardFooter className="flex justify-end border-t-2 py-2">
              {activeStep === 0 && (
                <>
                  <Button
                    variant="text"
                    color="red"
                    onClick={handleOpenCreateDialog}
                    className="mr-1"
                  >
                    <span>Cancel</span>
                  </Button>
                  <Button
                    variant="gradient"
                    color="green"
                    onClick={handleNext}
                  // disabled={activeNextStep}
                  >
                    <span>Next</span>
                  </Button>
                </>
              )}

              {activeStep === 1 && (
                <>
                  <Button
                    variant="text"
                    color="red"
                    onClick={handleBack}
                    className="mr-1"
                  >
                    <span>Back</span>
                  </Button>
                  <Button
                    variant="gradient"
                    color="green"
                    onClick={handleSubmit}
                    loading={isLoadingButton ? true : false}
                  >
                    <span>Submit</span>
                  </Button>
                </>
              )}
            </CardFooter>
          </Card>
        </form>
      </Dialog>
      {/* Create new Dailog Box End */}
    </div>
  );
}
